import { put, call } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { addCartAction, IAddCartParam } from '@app/react/action/AddCartAction';
import { api } from '@app/react/common/api';
import {
    AddCart,
    ArrowType,
    OrderType,
} from '@app/react/const/type';
import { ApiResponse } from '@app/react/api';
import { conv, convArrowType, convOrderType, PostSelectedItems } from '@app/react/saga/conv';
import { safe } from '@app/react/saga/common/safe';

const addCartAPI = (
    csrf: string,
    arrowType: ArrowType,
    orderType: OrderType,
    parts: PostSelectedItems,
) => {
    const at = convArrowType(arrowType);
    const ot = convOrderType(orderType);
    const addCart: AddCart = {
        arrowType: at,
        orderType: ot,
        selectedItems: parts,
    };

    return api.orderMadeFunctionAddCartPostRaw({
        addCart,
        eCCUBECSRFTOKEN: csrf,
    });
};

export function* addCartFlow(action: Action<IAddCartParam>): Generator {
    const {
        csrf, arrowType, orderType, parts,
    } = action.payload;

    const selectedItems = conv(parts);

    type RT = { result: ApiResponse<void>, error: Response };
    const { result, error }: RT = yield safe(
        call(addCartAPI, csrf, arrowType, orderType, selectedItems),
    );

    if (error !== null) {
        console.error('[saga] addCartFlow error:', error);
        yield put(
            addCartAction.failed({
                params: action.payload,
                error: {
                    status: error.status,
                    statusText: error.statusText,
                },
            }),
        );
        return;
    }

    const res = result.raw;
    const sts = res.status;
    switch (sts) {
        case 200: {
            yield put(
                addCartAction.done({
                    params: action.payload,
                    result: {},
                }),
            );
            break;
        }
        default: {
            yield put(
                addCartAction.failed({
                    params: action.payload,
                    error: {
                        status: res.status,
                        statusText: res.statusText,
                    },
                }),
            );
            break;
        }
    }
}
